import { RefObject, useEffect } from 'react';

type Params = {
  ref: RefObject<HTMLDivElement | null>;
  step: number;
  targetStep: number;
  onDotClick: () => void;
  delay?: number;
};

export function useSliderDotClick({ ref, step, targetStep, onDotClick, delay = 500 }: Params) {
  useEffect(() => {
    if (step !== targetStep) return;

    const timer = setTimeout(() => {
      if (!ref?.current) return;

      const dot = ref.current.querySelector('.ant-slider .ant-slider-dot') as HTMLDivElement | null;

      if (!dot) return;

      dot.addEventListener('click', onDotClick);

      return () => {
        dot.removeEventListener('click', onDotClick);
      };
    }, delay);

    return () => clearTimeout(timer);
  }, [step, targetStep, ref, onDotClick, delay]);
}
